import React from 'react'

export default function AbmPlaybook() {
  return (
    <div>
       <div class="service_area abmplaybook-component mt-3 mt-md-5">
       <div class="section_title text_center">
              
              
        </div> 
      <div class="container mt-5">
        <div class="row align-items-center">
          <div class="col-lg-6 col-md-6 col-sm-12 event d-flex justify-content-center mb-md-0">
            <div class="service_style_two playbook">
              <div class="service_style_two_number mr-60 w-30">
             <a href="https://7772074d.flowpaper.com/ThePrecisionABMPlaybookbyProPlusData/" target="_blank" rel="noopener noreferrer">
                <img src='assets/images/big-abm-playbook.png' className="img-fluid" alt="abm-playbook"/>
              </a>
              </div>
           
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="service_style_two">
           
              <div class="service_style_two_content">
               <div class="service_style_two_number mr-60 w-30">
              <img src='assets/images/abm-playbook-content.svg' className="img-fluid" alt="ABM-playbook"/>
              </div>
                <div class="service_style_two_text text-left">
                 
                  <div class="button three past-event mt-50 mt-md-5">
                <a href="https://7772074d.flowpaper.com/ThePrecisionABMPlaybookbyProPlusData/" target="_blank" rel="noopener noreferrer">Access Playbook</a>
              </div>
                </div>
              </div>
            </div>
          </div>
       
         
      
         
        </div>

        <div class="row align-items-center mt-5">
          <div class="col-lg-6 col-md-6 col-sm-12 event d-flex justify-content-center mt-5 mb-md-0">
            <div class="service_style_two mb-4 playbook">
              <div class="service_style_two_number mr-60 w-30">
             <a href="https://7772074d.flowpaper.com/GTMPlaybook/" target="_blank" rel="noopener noreferrer">
                <img src='assets/images/gtm-playbook.webp' className="img-fluid" alt="gtm-playbook"/>
              </a>
              </div>
           
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="service_style_two mb-4">
           
              <div class="service_style_two_content">
               <div class="service_style_two_number mr-60 w-30">
              <img src='assets/images/playbook.svg' className="img-fluid" alt="GTM-playbook"/>
              </div>
                <div class="service_style_two_text text-left">
                 
                  <div class="button three past-event mt-50">
                <a href="https://7772074d.flowpaper.com/GTMPlaybook/" target="_blank" rel="noopener noreferrer">Access Playbook</a>
              </div>
                </div>
              </div>
            </div>
          </div>
       
         
      
         
        </div>
      </div>
    </div>
    </div>
  )
}
